(function () {
  if (window.__FJ_CART_RUNTIME_20260818__) return;
  window.__FJ_CART_RUNTIME_20260818__ = true;

  var PAYMENT_ORDER = ['visa', 'mastercard', 'amex', 'apple', 'google', 'shop'];
  var ALLOWED_PAYMENTS = [
    { key: 'visa', needles: ['visa'] },
    { key: 'mastercard', needles: ['mastercard', 'master-card', 'master_card'] },
    { key: 'amex', needles: ['american_express', 'american-express', 'american express', 'amex'] },
    { key: 'apple', needles: ['apple_pay', 'apple-pay', 'apple pay'] },
    { key: 'google', needles: ['google_pay', 'google-pay', 'google pay'] },
    { key: 'shop', needles: ['shop_pay', 'shop-pay', 'shop pay', 'shopify_pay', 'shopify-pay'] }
  ];

  function paymentKey(el) {
    var blob = [
      el.innerHTML || '',
      el.textContent || '',
      el.getAttribute('aria-label') || '',
      el.getAttribute('title') || '',
      el.className || ''
    ].join(' ').toLowerCase();

    for (var i = 0; i < ALLOWED_PAYMENTS.length; i++) {
      var item = ALLOWED_PAYMENTS[i];
      for (var j = 0; j < item.needles.length; j++) {
        if (blob.indexOf(item.needles[j]) !== -1) return item.key;
      }
    }
    return '';
  }

  function setDiscountCopy(root) {
    if (root.getAttribute('data-fj-has-discount') !== '1') return;

    var mobileLabel = root.querySelector('.fj-cart-summary__discount .fj-cart-summary__label');
    if (!mobileLabel) return;

    var current = (mobileLabel.textContent || '').toLowerCase();
    var phrase = current.indexOf('20%') !== -1 ? '20% discount applied' : 'Discount applied';
    var expected = '✓ ' + phrase;

    if ((mobileLabel.textContent || '').trim() !== expected) {
      mobileLabel.textContent = '';
      var check = document.createElement('span');
      check.className = 'fj-cart-summary__discount-check';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = '✓';
      mobileLabel.appendChild(check);
      mobileLabel.appendChild(document.createTextNode(' ' + phrase));
    }

    var promo = root.querySelector('.fj-cart-summary__promo-trigger--mobile');
    if (promo && promo.textContent.trim() !== expected) promo.textContent = expected;

    var desktopStrong = root.querySelector('.fj-row--savings .fj-savings-strong');
    if (desktopStrong && phrase.indexOf('20%') === 0 && desktopStrong.textContent.trim() !== '20% DISCOUNT APPLIED') {
      desktopStrong.textContent = '20% DISCOUNT APPLIED';
    }
  }

  function addFinancing(root) {
    if (root.querySelector('.fj-cart-financing-fixed')) return;
    var actions = root.querySelector('.fj-actions');
    var checkout = root.querySelector('.fj-checkout-btn');
    if (!actions || !checkout) return;

    var box = document.createElement('div');
    box.className = 'fj-cart-financing-fixed';
    box.setAttribute('role', 'note');
    box.setAttribute('aria-label', 'Financing options');
    box.innerHTML = '<div class="fj-cart-financing-fixed__title">Pay over time</div>' +
      '<div class="fj-cart-financing-fixed__brands">' +
        '<span class="fj-cart-financing-fixed__affirm">Affirm</span>' +
        '<span class="fj-cart-financing-fixed__shop"><span class="fj-cart-financing-fixed__shop-mark">Shop Pay</span> Installments</span>' +
      '</div>' +
      '<div class="fj-cart-financing-fixed__note">Choose Affirm or Shop Pay Installments at checkout · Subject to eligibility and approval.</div>';

    actions.insertBefore(box, checkout);
  }

  function trimAndOrderPaymentLogos(root) {
    var container = root.querySelector('.fj-cart-summary__payment-icons');
    if (!container || container.getAttribute('data-fj-payment-order-fixed') === '1') return;

    var methods = Array.prototype.slice.call(container.querySelectorAll('.fj-cart-summary__payment-method'));
    if (!methods.length) return;

    var byKey = {};
    methods.forEach(function (method) {
      method.removeAttribute('data-fj-payment-hide');
      var key = paymentKey(method);
      if (key && !byKey[key]) byKey[key] = method;
    });

    if (Object.keys(byKey).length >= 4) {
      methods.forEach(function (method) {
        method.setAttribute('data-fj-payment-hide', '1');
      });
      PAYMENT_ORDER.forEach(function (key) {
        var method = byKey[key];
        if (!method) return;
        method.removeAttribute('data-fj-payment-hide');
        container.appendChild(method);
      });
    } else {
      methods.forEach(function (method, index) {
        if (index >= 6) method.setAttribute('data-fj-payment-hide', '1');
      });
    }

    container.setAttribute('data-fj-payment-order-fixed', '1');
  }

  function getMaterialSource(root) {
    var parent = root.parentElement;
    if (parent) {
      var local = parent.querySelector('[data-fj-cart-material-source]');
      if (local) return local;
    }
    return document.querySelector('[data-fj-cart-material-source]');
  }

  function applyMaterialLabel(root) {
    var source = getMaterialSource(root);
    if (!source) return;
    var label = (source.getAttribute('data-fj-cart-material-label') || '').trim();
    if (!label) return;

    var mobile = root.querySelectorAll('.fj-cart-trust__mobile');
    if (mobile.length && (mobile[0].textContent || '').trim() !== label) mobile[0].textContent = label;

    var desktop = root.querySelectorAll('.fj-cart-trust__desktop');
    if (desktop.length && (desktop[0].textContent || '').trim() !== ('✔ ' + label)) desktop[0].textContent = '✔ ' + label;
  }

  function getEasternParts() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date());
    var values = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = part.value;
    });
    return {
      year: Number(values.year), month: Number(values.month), day: Number(values.day),
      hour: Number(values.hour), minute: Number(values.minute), second: Number(values.second)
    };
  }

  function toDateOnly(parts) {
    return new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
  }

  function formatDateKey(date) {
    return [date.getUTCFullYear(), String(date.getUTCMonth() + 1).padStart(2, '0'), String(date.getUTCDate()).padStart(2, '0')].join('-');
  }

  function nthWeekdayOfMonth(year, month, weekday, occurrence) {
    var first = new Date(Date.UTC(year, month, 1));
    var offset = (weekday - first.getUTCDay() + 7) % 7;
    return new Date(Date.UTC(year, month, 1 + offset + ((occurrence - 1) * 7)));
  }

  function lastWeekdayOfMonth(year, month, weekday) {
    var last = new Date(Date.UTC(year, month + 1, 0));
    var offset = (last.getUTCDay() - weekday + 7) % 7;
    return new Date(Date.UTC(year, month, last.getUTCDate() - offset));
  }

  function getFedExClosedDates(year) {
    return new Set([
      year + '-01-01',
      formatDateKey(lastWeekdayOfMonth(year, 4, 1)),
      year + '-07-04',
      formatDateKey(nthWeekdayOfMonth(year, 8, 1, 1)),
      formatDateKey(nthWeekdayOfMonth(year, 10, 4, 4)),
      year + '-12-25'
    ]);
  }

  function isBusinessDay(date) {
    var day = date.getUTCDay();
    if (day === 0 || day === 6) return false;
    return !getFedExClosedDates(date.getUTCFullYear()).has(formatDateKey(date));
  }

  function nextBusinessDay(date) {
    var result = new Date(date.getTime());
    do { result.setUTCDate(result.getUTCDate() + 1); } while (!isBusinessDay(result));
    return result;
  }

  function addBusinessDays(date, amount) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < amount) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (isBusinessDay(result)) added += 1;
    }
    return result;
  }

  function formatDeliveryRange(startDate, endDate) {
    var startMonth = startDate.getUTCMonth();
    var endMonth = endDate.getUTCMonth();
    var startYear = startDate.getUTCFullYear();
    var endYear = endDate.getUTCFullYear();
    var monthFormatter = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short' });
    if (startYear === endYear && startMonth === endMonth) {
      return monthFormatter.format(startDate) + ' ' + startDate.getUTCDate() + '–' + endDate.getUTCDate();
    }
    var shortFormatter = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' });
    if (startYear === endYear) return shortFormatter.format(startDate) + '–' + shortFormatter.format(endDate);
    var yearFormatter = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' });
    return yearFormatter.format(startDate) + '–' + yearFormatter.format(endDate);
  }

  function resolveDelivery(root) {
    var targets = root.querySelectorAll('[data-fj-delivery-range]');
    if (!targets.length) return;
    var text = '2–3 business days';
    try {
      var cutoffHour = parseInt(root.getAttribute('data-fj-cutoff-hour') || '15', 10);
      var minDays = parseInt(root.getAttribute('data-fj-min-delivery-days') || '2', 10);
      var maxDays = parseInt(root.getAttribute('data-fj-max-delivery-days') || '3', 10);
      var parts = getEasternParts();
      var today = toDateOnly(parts);
      var currentSecond = (parts.hour * 3600) + (parts.minute * 60) + parts.second;
      var beforeCutoff = isBusinessDay(today) && currentSecond < (cutoffHour * 3600);
      var shipDate = beforeCutoff ? today : nextBusinessDay(today);
      var deliveryStart = addBusinessDays(shipDate, Math.min(minDays, maxDays));
      var deliveryEnd = addBusinessDays(shipDate, Math.max(minDays, maxDays));
      text = formatDeliveryRange(deliveryStart, deliveryEnd);
    } catch (e) {}
    targets.forEach(function (el) {
      if ((el.textContent || '').trim() !== text) el.textContent = text;
    });
  }

  function applyRoot(root) {
    setDiscountCopy(root);
    applyMaterialLabel(root);
    resolveDelivery(root);
    addFinancing(root);
    trimAndOrderPaymentLogos(root);
  }

  function applyAll() {
    document.querySelectorAll('[data-fj-cart-summary]').forEach(applyRoot);
  }

  window.FJCartRuntimeApply = applyAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll, { once: true });
  } else {
    applyAll();
  }

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      applyAll();
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  document.addEventListener('shopify:section:load', applyAll);
  window.addEventListener('pageshow', applyAll);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) applyAll();
  });
})();
